import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    image: {},
    desc: null,
    title: null,
    helpLink: null,
    helpText: null,    
};

const scSlice = createSlice({
    name: "pkzsc",
    initialState,
    reducers: {
        fillSharingContent(state, action) {
            state.image = action.payload.image;
            state.desc = action.payload.description;
            state.title = action.payload.title;
            state.helpLink = action.payload.helpLink;
            state.helpText = action.payload.helpText;
        },
        fuseSharingContent(state, action) {
            const {property, value} = action.payload;
            state[property] = value;
        },
    }
});

export const { fillSharingContent, fuseSharingContent } = scSlice.actions;
export default scSlice.reducer;